import React from 'react';
import {useState, useEffect} from 'react';
import Point from '../components/Admin/Point';
import Stamp from '../components/Admin/Stamp';
import TapBrc20 from '../components/Admin/TapBrc20';
import Holders from '../components/Admin/Holders';
import Brc20Tool from '../components/Admin/Brc20Tool';
import { useSelector, useDispatch } from 'react-redux';
import UpdateSrc101Domain from '../components/Admin/UpdateSrc101Domain';
import Brc20Presale_Iron from '../components/Admin/Brc20Presale_Iron';
import Brc20Presale_Glass from '../components/Admin/Brc20Presale_Glass';
import Brc20Ido from '../components/Admin/Brc20Ido';
import Brc20Presale from '../components/Admin/Brc20Presale';
import ValidateAddress from '../components/Admin/ValidateAddress';

export default function Admin() {
  const wallet = useSelector(state => state.wallet);
  const [tab, setTab] = useState(0);
  const [isWhitelisted, setIsWhiteListed] = useState(false);
  const whitelistAddresses = [
    "bc1p8egexv5nr0u6jqxrk5e03ey2fxww5fuxsdy22xw2w0pzc27c0m2qpzgxtd",
    "bc1prq4dlt4f0l9xlsdgc9g8p4tcdc9977p8zxpcua0q4f7cynfxdmesaw4hh8",
    "bc1p3ns3qgpmyv4j4q00kauvf0xnpg42kf9rc5259n5g3247vhr7yqeqcca3fv",
    "bc1p26005tzsk7ta64zuad59l29wkp2u7npgarss865ae5fj5f6g04nq5jxkpz",
    "bc1px0j5z4srk2u67rl8qkwcyk7agujzds6vpwh26f4hqpx9w9e7x7qqd74ar9"
  ]

  useEffect(() => {
    handleCheck(wallet.nostrOrdinalsAddress);
  }, [wallet.nostrOrdinalsAddress])

  const handleCheck = (address) => {
    let flag = false;
    for(let temp of whitelistAddresses) {
      if (temp == address) {
        flag = true;
        break;
      }
    }
    setIsWhiteListed(flag)
  }

  return (
    <div className="text-white mt-[65px] w-full md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      {
        isWhitelisted ? 
          <>
            <div className="flex md:flex-row flex-wrap gap-2 w-full mt-5">
              <div className={`md:text-[20px] text-[16px] ${tab == 0 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(0)}>POINT</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 1 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(1)}>STAMP</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 2 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(2)}>TAP2BRC20</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 3 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(3)}>HOLDERS</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 4 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(4)}>BRC20 AIRDROP</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 5 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(5)}>SRC101 DOMAIN</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 6 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(6)}>BRC20 PRESALE - 🝏</div>
              {/* <div className={`md:text-[20px] text-[16px] ${tab == 8 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(8)}>BRC20 PRESALE - 🝯</div> */}
              <div className={`md:text-[20px] text-[16px] ${tab == 7 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(7)}>BRC20 IDO</div>
              <div className={`md:text-[20px] text-[16px] ${tab == 8 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary px-4 py-1 rounded-md cursor-pointer`} onClick={() => setTab(8)}>VALIDATE ADDRESS</div>
            </div>
            {
              tab == 0 ? <Point /> : <></>
            }
            {
              tab == 1 ? <Stamp /> : <></>
            }
            {
              tab == 2 ? <TapBrc20 /> : <></>
            }
            {
              tab == 3 ? <Holders /> : <></>
            }
            {
              tab == 4 ? <Brc20Tool /> : <></>
            }
            {
              tab == 5 ? <UpdateSrc101Domain /> : <></>
            }
            {
              tab == 6 ? <Brc20Presale /> : <></>
            }
            {
              tab == 7 ? <Brc20Ido /> : <></>
            }
            {
              tab == 8 ? <ValidateAddress /> : <></>
            }
          </>
          :
          <div className="mt-[80px] text-2xl">
            Please connect using whitelisted wallet address.
          </div>
      }

    </div>
  )
}
